import { UserLoginService } from '@persistStores/UserLogin';
import { UserSessionService } from '@persistStores/UserSession';
import { ApiUserSession } from '@toptoon/api';
import ApiToken from '@toptoon/api/v2/ApiToken';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import UserDefault from './UserDefault';

const localeCallbackFromServer = (locale: string, localeString: string) => {
  UserDefault.setLocation(locale);
  UserDefault.setLocationString(localeString);
};
const versionCallbackFromServer = (version: string) => {
  UserDefault.setServerVersion(version);
};
const receivedUserId = (userId: string) => {
  UserDefault.HeaderUserId.setter(localStorage, userId);
};

/**
 * TODO api global hook 처리
 * @returns
 */
const ApiResponse = () => {
  const router = useRouter();
  useEffect(() => {
    const api = ApiUserSession.getInstance(UserDefault.getUserSession());

    const errorCallback = {
      onErrorAccessDenied: (action?: string) => {
        console.log('onErrorAccessDenied');
        // if (action === 'auth') {
        //   showMatureModal(history, null);
        // } else if (action === 'denied') {
        //   showIpBlockModal();
        // }
      },
      /**
       * TODO 해당 코드로 떨어질 경우 revokeToken으로 떨어질 경우 reloadToken 태움
       */
      onErrorLogout: () => {
        console.log('onErrorLogout');
        const info = UserSessionService.getUserInfo();

        if (info === null) {
          UserLoginService.userInfo.remove();
          // router.reload();
        }

        ApiToken.getInstance(UserDefault.getUserSession())
          .getReloadToken(info!.token, info!.revokeToken)
          .then((res: any) => {
            const { data } = res.data;
            // router.reload();
          })
          .catch((err: any) => {
            UserLoginService.userInfo.remove();
            // router.reload();
          });

        // if (Cookies.get('logoutTimeCheck')) return;

        // const inFifteenMinutes = new Date(new Date().getTime() + 2 * 1000);
        // Cookies.set('logoutTimeCheck', '1', { expires: inFifteenMinutes });

        // dispatch(reqClearToken());
        // dispatch(clearMature());
        // UserDefault.coinResetManual();
        // UserDefault.removeTemporyToken();
        // UserDefault.removeLoginCountCookie();
        // addToast(t('signUp.Logout'));
        // setReload(uuidv4());
      },
      onErrorRedirect: () => {
        console.log('onErrorRedirect');
        window.location.replace('/');
        // setReload(uuidv4());
      },
      // 유출자 진입시 예외처리
      onErrorBlockUser: () => {
        console.log('onErrorBlockUser');
        router.replace('/blockUSer');
        // dispatch(reqClearToken());
        // dispatch(clearMature());
        // UserDefault.coinResetManual();
        // UserDefault.removeTemporyToken();
        // UserDefault.removeLoginCountCookie();
        // addToast(t('signUp.Logout'));
        // setReload(uuidv4());

        // TODO: redirect 처리 route 추가 후 처리
        // window.location.replace('/blockUser');
      },
      // TODO: 유출자 혹은 의심자 회차리스트 진입시 예외처리
      onErrorDenied: () => {
        // dispatch(reqClearToken());
        // dispatch(clearMature());
        // UserDefault.coinResetManual();
        // UserDefault.removeTemporyToken();
        // UserDefault.removeLoginCountCookie();
        // addToast(t('signUp.Logout'));
        // setReload(uuidv4());

        // TODO: redirect 처리 route 추가 후 처리
        // window.location.replace('/505');
        console.log('onErrorDenied');
      },
    };

    api.addUserSessionController(
      errorCallback,
      localeCallbackFromServer,
      versionCallbackFromServer,
      receivedUserId,
    );
  }, []);

  return <></>;
};

export default ApiResponse;
